@for (address of addresses() | slice: 0 : limit(); track $index; let isLast = $last) {
    @let shortAddress = address.split("@")[0];
    <span class="hover-address">{{ addresses().length > 1 ? shortAddress : (address | fax) }}{{ isLast ? "" : delimiter() }}</span>
}
@if (addresses()?.length > limit()) {
    <div class="multi-address-snippet-container">
        <div
            [kno2Popover]="popover()"
            popoverTitle=""
            popoverPlacement="right">
            <div class="address-more ms-1">
                <span>
                    [
                    <i class="fa fa-plus-circle box-info"></i>
                    {{ addresses().length - limit() }} more ]
                </span>
            </div>
        </div>
    </div>
}
